import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Alert, 
  AlertTitle,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import TableAbstraction from "../../componentUtils/TableAbstraction";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import { GetBatchHistory } from "../../utils/GetAdmin";
import {checkForRole} from "../../utils/GetAuth";
import LockIcon from '@mui/icons-material/Lock';

import {
  WatchLater,
  Error,
  CheckCircle,
  Warning,
 } from '@mui/icons-material';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);
export default function BatchMonJobHist() {
  const classes = useStyles();
  const [batchHistory,setBatchHistory] = useState<any[]>([]);
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  const [doneLoading, setDoneLoading] = React.useState<boolean>();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const enabled = checkForRole(clientId,salesOrg,'security_admin');
  const [muiTable, setMuiTable] = React.useState<any>({rpp:25});

  const getStatusIcon = (hasError:boolean, isDone:boolean) =>{
    let icon = <WatchLater/>
    if(isDone) icon = <CheckCircle style={{color:"green"}}/>
    if(hasError) icon = <Error style={{color:"red"}}/>
    return icon
  }
  
  const header =  document.querySelector('ResponsiveDrawer')
  const headerAdj = header?header.clientHeight:250;
  const [TABLE_BODY_HEIGHT, setTABLE_BODY_HEIGHT] = React.useState<string>(`${window.innerHeight - headerAdj }px`);
  window.addEventListener('resize', ()=>{
    setTABLE_BODY_HEIGHT(`${window.innerHeight - headerAdj }px`);
  })
  
  useEffect(() => {
    if (doneLoading) return;
        GetBatchHistory(salesOrg).then((v) => {
          setDoneLoading(true);
          if(v){
            if(v.data && v.data.batchHistory){
              let remap:any[] = [];
              v.data.batchHistory.forEach((bh:any)=>{
                remap.push(
                  {
                    ...bh,
                    status: {hasError:bh.hasError,isDone:bh.isDone},
                  }
                )
              })
              setBatchHistory(remap);

            }
          }
        });
  }, [batchHistory, doneLoading, salesOrg]);
  return (
    <div className={classes.root}>
      {doneLoading && enabled? (
        <div>
          <TableAbstraction
            settingsKey="ADM_BMJH"
            options={{
              draggableColumns: {
                enabled: true,
              },
              rowsPerPageOptions: [25, 50, 100],
              tableBodyHeight: TABLE_BODY_HEIGHT,
              serverSide: false,
              selectableRows: "none",
              rowsPerPage: muiTable.rpp,
              onChangeRowsPerPage: (numberOfRows:any) => {
                muiTable.rpp = numberOfRows;
                setMuiTable(muiTable);
              },
            }}
            title="Job History"
            columns={[
              {
                label: "S",
                name: "status",
                options: {
                  searchable: true,
                  filter: false,
                  customBodyRender: (value:any) => (getStatusIcon(value.hasError,value.isDone))
                },
              },
              {
                label: "Type",
                name: "ProcessType",
                options: {
                  searchable: true,
                  filter: true,
                },
              },
              {
                label: "Name",
                name: "ProcessName",
                options: {
                  searchable: true,
                  filter: true,
                },
              },
              {
                label: "Run ID",
                name: "RunID",
                options: {
                  searchable: true,
                  filter: false,
                },
              },
              {
                label: "Start (Server Time)",
                name: "startTime",
                options: {
                  searchable: true,
                  filter: false,
                  customBodyRender: (value:any)=>((new Date(value)).toLocaleString())
                },
              },
              {
                label: "Seconds",
                name: "runSeconds",
                options: {
                  searchable: true,
                  filter: false,
                },
              },
              {
                label: "Error",
                name: "hasError",
                options: {
                  searchable: true,
                  filter: true,
                  customBodyRender: (value:any) =>((value === 1)?<Warning/>:<div/>)
                },
              },
            ]}
            data={batchHistory}
          />
      </div>
      ) : ( enabled ? (
        <div className={classes.centerDiv}>
          <CircularProgress color="primary" />
        </div>) : (
          <Alert severity="error">
            <AlertTitle><LockIcon/> Access Error</AlertTitle>   
            You do not currently have access to <strong>Security Admin</strong> activities for the <strong>{salesOrg}</strong> bottler. 
          </Alert>
        )
      )}
    </div>
  );
}